<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card to="/uncompleted" class="pa-4">
          <h1 class="mb-1 subtitle-2 red--text red--lighten-1">未完成</h1>
          <div class="d-flex justify-space-between align-end">
            <span class="display-1	font-weight-bold">{{
              data.unfinishedCount
            }}</span>
            <v-btn depressed small color="red lighten-5"
              >所有未完成&#8594;</v-btn
            >
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card to="/completed" class="pa-4">
          <h1 class="mb-1 subtitle-2 cyan--text text--darken-1">完成</h1>
          <div class="d-flex justify-space-between align-end">
            <span class="display-1	font-weight-bold">{{
              data.finishedCount
            }}</span>
            <v-btn depressed small color="cyan lighten-5"
              >所有完成&#8594;</v-btn
            >

            <!-- <a
              href="/"
              class="body-2 grey lighten-3 pa-2 cyan--text text--darken-4"
            ></a> -->
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { db } from "@/db";

export default {
  name: "Dashboard",

  data: () => ({
    data: {
      unfinishedCount: 0,
      finishedCount: 0
    }
  }),
  created() {
    db.collection("basicInfo")
      .doc("0")
      .get()
      .then(doc => {
        if (doc.exists) {
          this.data = {
            ...doc.data()
          };
        } else {
          // doc.data() will be undefined in this case
          // eslint-disable-next-line no-console
          console.log("No such document!");
        }
      });
  }
};
</script>
